/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { COMPONENT_NAME } from '../const.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-bfb23a5e.mjs';
import '../../_chunks/dep-a48de419.mjs';
import '../../_chunks/dep-2a7dc5c7.mjs';
import '../../_chunks/dep-9311bf66.mjs';
import '../../_chunks/dep-4889eb51.mjs';
import '../../_chunks/dep-0b4185fe.mjs';
import '../../_chunks/dep-3ca5fb38.mjs';
import '../../_chunks/dep-7071345f.mjs';
import '../../_chunks/dep-d2403b2f.mjs';
import '../../_chunks/dep-7922050a.mjs';
import '../../_chunks/dep-169ea640.mjs';
import '../../_chunks/dep-f6b25712.mjs';
import '../../_chunks/dep-59545a4d.mjs';
import '../../_chunks/dep-c27b1c14.mjs';
import '../../_chunks/dep-7d96367f.mjs';
import '../../_chunks/dep-827c4600.mjs';
import '../../_chunks/dep-0820e0e2.mjs';
import '../../_chunks/dep-caad2e91.mjs';
import '../../_chunks/dep-3d4aad09.mjs';
import '../../_chunks/dep-8e38f523.mjs';
import '../../_chunks/dep-469bf54b.mjs';
import '../../_chunks/dep-8ef9fb8e.mjs';
import '../../_chunks/dep-e769aafd.mjs';
import '../../_chunks/dep-400798c5.mjs';
import '../../_chunks/dep-361522ee.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../config-provider/type.mjs';

function useCalendarClass(props, state) {
  var prefixClass = usePrefixClass(COMPONENT_NAME);
  var body = computed(function () {
    return ["".concat(prefixClass.value), "".concat(prefixClass.value, "--").concat(props.theme)];
  });
  var panel = computed(function () {
    return ["".concat(prefixClass.value, "__panel"), "".concat(prefixClass.value, "__panel--").concat(state.curSelectedMode)];
  });
  var control = computed(function () {
    return ["".concat(prefixClass.value, "__control")];
  });
  var title = computed(function () {
    return ["".concat(prefixClass.value, "__title")];
  });
  var controlSection = computed(function () {
    return ["".concat(prefixClass.value, "__control-section")];
  });
  var controlSectionCell = computed(function () {
    return ["".concat(prefixClass.value, "__control-section-cell")];
  });
  var controlTag = computed(function () {
    return ["".concat(prefixClass.value, "__control-tag")];
  });
  var table = computed(function () {
    return ["".concat(prefixClass.value, "__table")];
  });
  var tableHead = computed(function () {
    return ["".concat(prefixClass.value, "__table-head")];
  });
  var tableHeadRow = computed(function () {
    return ["".concat(prefixClass.value, "__table-head-row")];
  });
  var tableHeadCell = computed(function () {
    return ["".concat(prefixClass.value, "__table-head-cell")];
  });
  var tableBody = computed(function () {
    return ["".concat(prefixClass.value, "__table-body")];
  });
  var tableBodyRow = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-row")];
  });
  return {
    body: body,
    panel: panel,
    control: control,
    title: title,
    controlSection: controlSection,
    controlSectionCell: controlSectionCell,
    controlTag: controlTag,
    table: table,
    tableHead: tableHead,
    tableHeadRow: tableHeadRow,
    tableHeadCell: tableHeadCell,
    tableBody: tableBody,
    tableBodyRow: tableBodyRow
  };
}
function useCalendarCellClass() {
  var prefixClass = usePrefixClass(COMPONENT_NAME);
  var tableBodyCell = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell")];
  });
  var tableBodyCell4Now = computed(function () {
    return "".concat(prefixClass.value, "__table-body-cell--now");
  });
  var tableBodyCellDisplay = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell-display")];
  });
  var tableBodyCellCsontent = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell-content")];
  });
  return {
    tableBodyCell: tableBodyCell,
    tableBodyCell4Now: tableBodyCell4Now,
    tableBodyCellDisplay: tableBodyCellDisplay,
    tableBodyCellCsontent: tableBodyCellCsontent
  };
}

export { useCalendarCellClass, useCalendarClass };
//# sourceMappingURL=useCalendarClass.mjs.map
